$(document).ready(function () {
    $(".downloads__button").on("click", function() {

        var chevron = $(this).find(".fa");

        $(this).parent().find(".downloads__link").toggleClass("downloads__link--show");
        chevron.toggleClass("fa-chevron-down");
        chevron.toggleClass("fa-chevron-up");
    });
});